exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cl-acc-orange[data-v-62a458a5]{color:#ae6010}.cookie[data-v-62a458a5]{z-index:3;bottom:0}.icon[data-v-62a458a5]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.icon[data-v-62a458a5]:hover{color:#191919;background-color:#442020}\n", ""]);

// exports
